// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__j3bvp","modalFooterButton":"ModalNotes_modalFooterButton__4RD4Z"};